"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var AttributeFilterDropdown_1 = require("./Dropdown/AttributeFilterDropdown");
var AttributeFilterComponentsContext_1 = require("../Context/AttributeFilterComponentsContext");
var AttributeFilterContext_1 = require("../Context/AttributeFilterContext");
/**
 * @internal
 */
exports.AttributeFilterRenderer = function () {
    var _a = AttributeFilterComponentsContext_1.useAttributeFilterComponentsContext(), LoadingComponent = _a.LoadingComponent, ErrorComponent = _a.ErrorComponent;
    var _b = AttributeFilterContext_1.useAttributeFilterContext(), isInitializing = _b.isInitializing, initError = _b.initError;
    if (isInitializing && LoadingComponent) {
        return react_1.default.createElement(LoadingComponent, null);
    }
    else if (initError) {
        return react_1.default.createElement(ErrorComponent, { message: initError.message, error: initError });
    }
    else {
        return react_1.default.createElement(AttributeFilterDropdown_1.AttributeFilterDropdown, null);
    }
};
//# sourceMappingURL=AttributeFilterRenderer.js.map